var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { InternalProvider } from '../../util/InternalProvider';
import { useId, useHoverState } from '../../util';
import { Label } from './radioSelectionCardElements';
export var RadioSelectionCard = React.forwardRef(function (_a, ref) {
    var id = _a.id, checked = _a.checked, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.containerClassName, containerClassName = _c === void 0 ? '' : _c, _d = _a.labelClassName, labelClassName = _d === void 0 ? '' : _d, _e = _a.toggleClassName, toggleClassName = _e === void 0 ? '' : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.showCircle, showCircle = _g === void 0 ? true : _g, children = _a.children, rest = __rest(_a, ["id", "checked", "className", "containerClassName", "labelClassName", "toggleClassName", "disabled", "showCircle", "children"]);
    var elementId = useId('radioSelectionCard', id);
    var _h = useHoverState(disabled), hoverState = _h.hoverState, onMouseOver = _h.onMouseOver, onMouseOut = _h.onMouseOut, onMouseDown = _h.onMouseDown, onMouseUp = _h.onMouseUp;
    var contentClassNames = "radioSelectionCard__content ".concat(labelClassName);
    if (showCircle === false) {
        contentClassNames += ' hideCircle';
    }
    return (React.createElement(InternalProvider, null,
        React.createElement(Label, { "$disabled": disabled, className: containerClassName, "$hoverState": hoverState, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onMouseOut: onMouseOut },
            React.createElement("input", __assign({ id: elementId, ref: ref }, rest, { checked: checked, type: "radio", className: "radioSelectionCard__input ".concat(className), disabled: disabled })),
            showCircle === true && (React.createElement("span", { className: "radioSelectionCard__toggle ".concat(toggleClassName) })),
            React.createElement("span", { className: contentClassNames }, children),
            React.createElement("span", { className: "radioSelectionCard__button" }))));
});
